<template>
  <div>
    <v-list-item
      v-for="(currentAction, i) in currentActions"
      :key="i"
      @click="changeComponent(currentAction[2])"
      :class="`${($route.name == currentAction[2]) ? 'activeH' : '' }`"
    >
      <v-list-item-action>
        <v-icon v-text="currentAction[1]"></v-icon>
      </v-list-item-action>

      <v-list-item-title v-text="currentAction[0]"></v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    currentActions() {
      return [
        [
          this.$t("page.series.expansion-panel.series-details"), 
          "fa-chevron-right", 
          "SerieDetails"
        ],
        [
          this.$t("page.series.expansion-panel.series-results"), 
          "fa-chevron-right", 
          "SerieResults"
        ]
      ];
    }
  },
  methods: {
    changeComponent(component, id = null) {
      this.$emit("isComponent", component, id);
      let params = this.$route.params;
        this.$router.push({
          name: component, params
        });
    },
  },
};
</script>

<style scoped>
.v-list-item__title {
  text-align: left;
}
.v-list-group__items > div > .v-list-item {
  padding-left: 30px;
}
.activeH {
  background-color: var(--v-accent-base) !important;
}
</style>
